import { render } from "./odn-form.vue?vue&type=template&id=251629eb"
const script = {}

import "./odn-form.vue?vue&type=style&index=0&id=251629eb&lang=scss"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__